/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { CAMPING_BASEPATH } from '../src/shared/constants';

export const getRoutesArray = () => {
    const childRoutes = [];

    // ===============================
    // Camping General Routes
    // ===============================

    // Campground Details (STANDARD) with nested campsite route
    childRoutes[childRoutes.length] = {
        path: `${CAMPING_BASEPATH}/campgrounds/:cGrndId`,
        componentName: 'CampgroundPage',
        requireAuth: false,
        title: 'Campground Details',
        children: [
            {
                path: 'campsites/:siteId',
                componentName: 'CampsitePage',
                requireAuth: false,
                title: 'Campsite Details',
            },
        ],
    };
    // ===== (end) =====

    // Campsite Itinerary
    childRoutes[childRoutes.length] = {
        path: `${CAMPING_BASEPATH}/mobile/reservation/create`,
        componentName: 'MobileCreateReservationPage',
        requireAuth: true,
        title: 'Create Reservation',
    };

    // Standalone Campsite Details (fallback for direct links)
    childRoutes[childRoutes.length] = {
        path: `${CAMPING_BASEPATH}/campsites/:siteId`,
        componentName: 'CampsitePage',
        requireAuth: false,
        title: 'Campsite Details',
    };

    // Campsite Order Details
    childRoutes[childRoutes.length] = {
        path: `${CAMPING_BASEPATH}/reservations/orderdetails`,
        componentName: 'OrderDetailsPage',
        requireAuth: true,
        title: 'Campsite Order Details',
    };

    // Point of Interest
    childRoutes[childRoutes.length] = {
        path: `${CAMPING_BASEPATH}/poi/:recId`,
        componentName: 'PointOfInterestPage',
        requireAuth: false,
        title: 'Point of Interest',
    };

    return childRoutes;
};

export default getRoutesArray();
